export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./system-settings.vue?vue&type=template&id=ed8eabf6"


//////////////////
// WEBPACK FOOTER
// ./src/components/system/system-settings.vue?vue&type=template&id=ed8eabf6
// module id = 1R0r
// module chunks = 0